module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Shopping/Euro-c5f4c434335afdb342cd5cb71a25502096fa2513886c1102a4dfb3401cb13b65.svg";